import { render, staticRenderFns } from "./ShowAIResponseSetting.vue?vue&type=template&id=04ceb365&scoped=true"
import script from "./ShowAIResponseSetting.vue?vue&type=script&lang=js"
export * from "./ShowAIResponseSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ceb365",
  null
  
)

export default component.exports